module.exports = __webpack_public_path__ + "img/pencil.8d6f6f2.png";